import React, { useRef } from "react";
import clsx from "clsx";
import { Button, Form, TextField, Switch, FormControlLabel } from "@curves/ui-base";
import GradientColorHeader from "@icoach/components/dialog/GradientColorHeader";
import { Dialog, DialogActions, DialogContent, Grid } from "@mui/material";
import { useMemberProfileApi } from "@apis/useMemberProfileApi";
import { isFunction, refIsRequiredError } from "@util/utils";

const MeasureDayDialog = React.forwardRef((props, ref) => {
	const { className, open, sourceData, onClose, refresh } = props;
	if (!open) return null;
	const { memberID, measureDay, showInterviewNotMeasureIcon = true, isInterviewNotMeasure } = sourceData || {};

	const { postMemberProfileMeasureDayApi } = useMemberProfileApi();

	const measureDayRef = useRef(null);
	const isInterviewNotMeasureRef = useRef(null);

	const doMemberProfileMeasureDayApi = async (memberID, params) => {
		let resp = await postMemberProfileMeasureDayApi(memberID, params);
		if (resp) {
			isFunction(refresh) && refresh(resp);
			isFunction(onClose) && onClose();
		}
	};

	const handleSubmit = () => {
		if (!refIsRequiredError(measureDayRef)) {
			let params = {
				measureDay: measureDayRef.current && measureDayRef.current.getResult(),
				isInterviewNotMeasure,
			};

			if (showInterviewNotMeasureIcon) {
				params.isInterviewNotMeasure = isInterviewNotMeasureRef.current && isInterviewNotMeasureRef.current.checked;
			}

			doMemberProfileMeasureDayApi(memberID, params);
		}
	};

	return (
		<Dialog className={clsx("simple-content", "dialog", className)} PaperProps={{ className: "wx-40rem", component: Form }} onSubmit={handleSubmit} open={open} fullWidth>
			<GradientColorHeader onClose={onClose}>量身日</GradientColorHeader>
			<DialogContent>
				<Grid container>
					<Grid item xs={12}>
						<TextField label="量身日" ref={measureDayRef} defaultValue={measureDay} inputProps={{ placeholder: "請輸入", max: 30, min: 1 }} type={"number"} fullWidth required />
					</Grid>
					{showInterviewNotMeasureIcon && (
						<Grid item xs={12}>
							<FormControlLabel
								label="只面談不量身"
								key={isInterviewNotMeasure}
								control={<Switch inputProps={{ ref: isInterviewNotMeasureRef }} defaultChecked={isInterviewNotMeasure} />}
								className="m-0"
								labelPlacement="start"
							/>
						</Grid>
					)}
				</Grid>
			</DialogContent>
			<DialogActions>
				<Button type={"submit"} variant="contained">
					確認送出
				</Button>
			</DialogActions>
		</Dialog>
	);
});

export default MeasureDayDialog;
